import React, { useEffect, useState } from "react";
import { Tag, Check, Lock } from "lucide-react";
import { api, inr } from "@/lib/api";

const benefit = (o) => (o.type === "percent" ? `${o.value}% OFF` : `${inr(o.value)} OFF`);
const KIND = { festive: "Festive offer", first_order: "First order", bulk: "Bulk order", general: "" };

const conditions = (o) => [
  o.min_order ? `Min order ${inr(o.min_order)}` : "No minimum",
  o.max_discount ? `Max ${inr(o.max_discount)} off` : null,
  o.eligible_categories?.length ? `On ${o.eligible_categories.join(", ")}` : null,
  o.bulk_min_qty ? `${o.bulk_min_qty}+ boxes` : null,
  o.per_customer_limit ? `${o.per_customer_limit}× per customer` : null,
  o.expires_at ? `Till ${new Date(o.expires_at).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}` : null,
].filter(Boolean).join(" · ");

export const OffersList = ({ items, giftWrap, applied, onApply, refreshKey }) => {
  const [offers, setOffers] = useState([]);
  useEffect(() => {
    if (!items.length) return;
    api.post("/checkout/offers", { items, gift_wrap: giftWrap }).then((r) => setOffers(r.data)).catch(() => setOffers([]));
  }, [refreshKey]); // eslint-disable-line
  if (!offers.length) return null;
  return (
    <div className="mb-4" data-testid="offers-list">
      <p className="text-[10px] uppercase tracking-widest text-[#8C7B6E] mb-2">Available offers</p>
      <div className="space-y-2 max-h-72 overflow-y-auto pr-1">
        {offers.map((o) => {
          const isApplied = applied === o.code;
          return (
            <div key={o.code} data-testid={`offer-${o.code}`}
              className={`rounded-lg border p-3 transition-colors ${isApplied ? "border-[#2E7D32]/60 bg-[#2E7D32]/10" : o.eligible ? "border-[#3B251D] hover:border-[#D4AF37]" : "border-[#3B251D] opacity-55"}`}>
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <p className="flex items-center gap-2 flex-wrap">
                    <span className="font-mono-lux text-sm text-[#D4AF37] border border-dashed border-[#D4AF37]/60 rounded px-1.5">{o.code}</span>
                    <span className="text-xs font-semibold text-[#FDFBF7]">{benefit(o)}</span>
                    {KIND[o.offer_type] && <span className="text-[9px] uppercase tracking-wider text-[#8C7B6E]">{KIND[o.offer_type]}</span>}
                  </p>
                  <p className="text-[10px] text-[#8C7B6E] mt-1">{conditions(o)}</p>
                  {o.eligible && o.discount > 0 && !isApplied && <p className="text-[10px] text-[#7BC47F] mt-0.5">You save {inr(o.discount)}</p>}
                  {!o.eligible && <p data-testid={`offer-reason-${o.code}`} className="text-[10px] text-[#E6C594] mt-0.5 flex items-center gap-1"><Lock size={10} /> {o.reason}</p>}
                </div>
                {isApplied ? (
                  <span data-testid={`offer-applied-${o.code}`} className="text-[11px] text-[#7BC47F] flex items-center gap-1 shrink-0"><Check size={13} /> Applied</span>
                ) : (
                  <button data-testid={`offer-apply-${o.code}`} disabled={!o.eligible} onClick={() => onApply(o.code)}
                    className="text-[11px] font-semibold text-[#D4AF37] border border-[#D4AF37]/60 rounded-full px-3 py-1 shrink-0 hover:bg-[#D4AF37] hover:text-[#1A0F0B] transition-colors disabled:pointer-events-none disabled:opacity-60 flex items-center gap-1">
                    <Tag size={11} /> Apply
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
